'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var LIST_TYPES = ['numbered-list', 'bulleted-list'];

exports.LIST_TYPES = LIST_TYPES;
